"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _scoreBar = require("./score-bar");
Object.keys(_scoreBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _scoreBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _scoreBar[key];
    }
  });
});